// Single source of truth for the OTA patch version.
// Bumped by the EAS Deploy workflow on every OTA update, reset to 0 on native builds.
// Do NOT edit manually — the workflow manages this via CI.
export const PATCH_VERSION = 24;

// React Query persist cache version. Bump manually when a backend contract
// change (RPC shape, edge function response, etc.) requires invalidating the
// persisted AsyncStorage cache. Included in the persist buster so existing
// users get a clean re-fetch on next launch.
export const CACHE_VERSION = 2;
